module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalClasses = []\nconst isEmpty \t\t\t= !model.dataINT || model.dataINT === null\nconst fieldConfig \t\t= model.config || {}\nconst placeholderKey \t= fieldConfig.placeholderKey || ''\nconst placeholder \t\t= storage.__(placeholderKey) || ''\nif(model.active) \t\tadditionalClasses.push('active');\nif(isEmpty)\t\t\t\tadditionalClasses.push('empty');\nif(model.disabled)\t\tadditionalClasses.push('disabled');\nif(fieldConfig.style)\tadditionalClasses.push(fieldConfig.style);\n%>\n<div class=\"<%= additionalClasses.join(' ') %>\" title=\"<%= placeholder %>\">\n<div class=\"icon <%= fieldConfig.icon || config.icon || '' %>\"></div>\n<%\nif(fieldConfig.additionalControls === false){\n%>\n<div class=\"value\"><%= model.dataINT || '0' %></div>\n<%\n} else {\n%>\n<div class=\"controls\">\n<button class=\"minus\">\n<i class=\"fi fi-minus-square\"></i>\n</button>\n<div class=\"value\"><%= model.dataINT || '0' %></div>\n<button class=\"plus\">\n<i class=\"fi fi-plus-square\"></i>\n</button>\n</div>\n<%\n}\n%>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\nrOfElements.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalClasses = []
const isEmpty 			= !model.dataINT || model.dataINT === null
const fieldConfig 		= model.config || {}
const placeholderKey 	= fieldConfig.placeholderKey || ''
const placeholder 		= storage.__(placeholderKey) || ''
if(model.active) 		additionalClasses.push('active');
if(isEmpty)				additionalClasses.push('empty');
if(model.disabled)		additionalClasses.push('disabled');
if(fieldConfig.style)	additionalClasses.push(fieldConfig.style);

    ; __line = 11
    ; __append("\n<div class=\"")
    ; __line = 12
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\" title=\"")
    ; __append(escapeFn( placeholder ))
    ; __append("\">\n<div class=\"icon ")
    ; __line = 13
    ; __append(escapeFn( fieldConfig.icon || config.icon || '' ))
    ; __append("\"></div>\n")
    ; __line = 14
    ; 
if(fieldConfig.additionalControls === false){

    ; __line = 16
    ; __append("\n<div class=\"value\">")
    ; __line = 17
    ; __append(escapeFn( model.dataINT || '0' ))
    ; __append("</div>\n")
    ; __line = 18
    ; 
} else {

    ; __line = 20
    ; __append("\n<div class=\"controls\">\n<button class=\"minus\">\n<i class=\"fi fi-minus-square\"></i>\n</button>\n<div class=\"value\">")
    ; __line = 25
    ; __append(escapeFn( model.dataINT || '0' ))
    ; __append("</div>\n<button class=\"plus\">\n<i class=\"fi fi-plus-square\"></i>\n</button>\n</div>\n")
    ; __line = 30
    ; 
}

    ; __line = 32
    ; __append("\n</div>")
    ; __line = 33
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\nrOfElements.ejs

}